<div class="popup-backdrop" (click)="PopupEvent('close')" *ngIf="popup?.Display">
</div>
<div class="popup-component" *ngIf="popup?.Display">
  <div class="popup-container notification-popup">
    <!--popup content - container for popup content (do not change styling )-->
    <div class="popup-content">

      <!-- popup header-->
      <div class="popup-header" *ngIf="popup?.Title">
        <h2>{{ popup?.Title }}</h2>
      </div>
      <!-- popup body -->
      <div class="popup-body">
        <div class="info-popup" *ngIf="popup?.MessageType == 'info'">
          <p>{{ popup?.Message }} </p>
        </div>

        <div class="success-popup" *ngIf="popup?.MessageType == 'success'">
          <p>{{ popup?.Message }} </p>
          <span class="success-popup-icon"><i class="fa-solid fa-check" aria-hidden="true"></i></span>
        </div>

        <div class="error-popup" *ngIf="popup?.MessageType == 'error'">
          <p>{{ popup?.Message }} </p>
        </div>
        <div class="popup-buttons">
          <button type="button" (click)="ButtonClick()" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.ButtonText" (click)="AltButtonClick()" class="popup-btn">{{ popup?.AltButton?.ButtonText }}</button>
        </div>
      </div>
      <!-- popup footer - popup buttons-->



    </div>
  </div>
</div>
